export default "__VITE_ASSET__P9jHmbaU__"